import { ITransactionDetails } from "./transactionDetails.types"

export class TransactionDetails implements ITransactionDetails {
  id: number
  reference: string
  createdUser?: string

  constructor(id: number, reference: string, createdUser?: string) {
    this.createdUser = createdUser
    this.id = id
    this.reference = reference
  }
}
